import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Dropdown } from "../../../FlowConfigurationInputs";

export default function ConvertDate({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const options = {
    dropdown: {
      data: [
        {
          value: "dd-mm-yyyy",
          label: "DD-MM-YYYY",
        },
        {
          value: "mm-dd-yyyy",
          label: "MM-DD-YYYY",
        },
        {
          value: "yyyy-mm-dd",
          label: "YYYY-MM-DD",
        },
        {
          value: "dd.mm.yyyy",
          label: "DD.MM.YYYY",
        },
        {
          value: "mm.dd.yyyy",
          label: "MM.DD.YYYY",
        },
        {
          value: "yyyy.mm.dd",
          label: "YYYY.MM.DD",
        },
        {
          value: "dd/mm/yyyy",
          label: "DD/MM/YYYY",
        },
        {
          value: "mm/dd/yyyy",
          label: "MM/DD/YYYY",
        },
        {
          value: "yyyy/mm/dd",
          label: "YYYY/MM/DD",
        },
      ],
      defaultValue: "dd-mm-yyyy",
    }
  };
  
  return (
    <div>
      <div className="form-element">
        {t(label + "SOURCESTRING")}
        <TextInput
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          inputName="sourceString"
          isRequired={true}
          fieldType="string" displayName={t(label + 'SOURCESTRING')}
        />
      </div>
      <div className="form-element">
        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
          <div >
            {t(label + "SOURCE-FORMAT-TYPE")}
            <Dropdown
              action={action}
              inputName="sourceFormat"
              options={options.dropdown}
              isRequired={true}
            />
          </div>
        </div>
      </div>
      <div className="form-element">
        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
          <div>
            {t(label + "DATE-FORMAT-TYPE")}
            <Dropdown
              action={action}
              inputName="newFormat"
              options={options.dropdown}
              isRequired={true}
            />
          </div>
        </div>
      </div>
      <div className="form-element">
        {t(label + "ASSIGN_TO_VARIABLE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          filter="date"
          isRequired={true}
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'date' })}</em></small>
      </div>
    </div>
  );
}